const test = [
  {
    questions: [{
      text: '超過十萬人購買的oversize牛仔外套',
      tag: 'identity'
    }, {
      text: '來店消費就送日韓可愛毛毛襪',
      tag: 'reciprocity'
    }]
  }
];

export default test;



// WEBPACK FOOTER //
// ./app/data/test.js